export enum CentralSystemStatus {
  Online = 'online',
  Offline = 'offline',
}
